var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 21.1438 0 11.7157 5.85786 5.85786C11.7157 0 21.1438 0 40 0H42C60.8562 0 70.2843 0 76.1421 5.85786C82 11.7157 82 21.1438 82 40V42C82 60.8562 82 70.2843 76.1421 76.1421C70.2843 82 60.8562 82 42 82H40C21.1438 82 11.7157 82 5.85786 76.1421C0 70.2843 0 60.8562 0 42V40Z",
    fill: "#F8D57E",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M36.7998 52.55L29.4498 45.2L26.2178 54.1086C26.1284 54.3424 26.1086 54.597 26.1608 54.8417C26.213 55.0865 26.335 55.3109 26.5119 55.4879C26.6889 55.6648 26.9133 55.7868 27.1581 55.839C27.4028 55.8912 27.6574 55.8714 27.8912 55.782L36.7998 52.55Z",
    fill: "#F8D57E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.612 44.8424L52.6122 44.8426C52.7604 44.9895 52.8691 45.1716 52.9281 45.3717C52.9871 45.5719 52.9946 45.7838 52.9498 45.9877C52.905 46.1915 52.8094 46.3807 52.6719 46.5377C52.5344 46.6948 52.3595 46.8145 52.1633 46.8858L45.4812 49.3141L32.6855 36.5185L35.1139 29.8363C35.1852 29.6402 35.3049 29.4652 35.4619 29.3277C35.6189 29.1902 35.8081 29.0946 36.012 29.0498C36.2158 29.0051 36.4277 29.0125 36.6279 29.0715C36.8281 29.1306 37.0101 29.2392 37.1571 29.3875L37.1573 29.3877L52.612 44.8424Z",
    fill: "#F8D57E",
    stroke: "#F8D57E",
    strokeWidth: 0.148438
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2178 54.1086L35.0443 29.811C35.1199 29.6031 35.2468 29.4176 35.4132 29.2719C35.5796 29.1261 35.7802 29.0248 35.9963 28.9773C36.2123 28.9299 36.4369 28.9378 36.6491 29.0004C36.8613 29.0629 37.0542 29.1781 37.2099 29.3352L52.6646 44.7899C52.8217 44.9456 52.9369 45.1386 52.9995 45.3508C53.062 45.563 53.0699 45.7875 53.0225 46.0036C52.975 46.2196 52.8737 46.4202 52.728 46.5866C52.5822 46.7531 52.3968 46.8799 52.1888 46.9555L27.8912 55.7821C27.6574 55.8714 27.4028 55.8912 27.1581 55.839C26.9133 55.7868 26.6889 55.6648 26.5119 55.4879C26.335 55.3109 26.213 55.0865 26.1608 54.8418C26.1086 54.597 26.1284 54.3424 26.2178 54.1086V54.1086Z",
    stroke: "#F8D57E",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5625 31.8125C47.5625 31.8125 47.5625 27.875 51.5 27.875C55.4375 27.875 55.4375 23.9375 55.4375 23.9375",
    stroke: "#F8D57E",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8002 52.55L29.4502 45.2",
    stroke: "#F8D57E",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.625 22.625V26.5625",
    stroke: "#F8D57E",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4375 38.375L58.0625 41",
    stroke: "#F8D57E",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4375 33.125L59.375 31.8125",
    stroke: "#F8D57E",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5996 36.5375L45.4621 49.4",
    stroke: "#F8D57E",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon-2.487df7ce993894229e451e6a1845c5d7.svg";
export { ForwardRef as ReactComponent };